import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionBikeRack"
const OptionBikeRackIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m18.5 19.5c-1.657 0-3-1.343-3-3 0-1.171.671-2.186 1.65-2.68l.617 2.839c.088.405.487.662.892.574s.662-.487.574-.892l-.617-2.839c1.603.061 2.884 1.38 2.884 2.998 0 1.657-1.343 3-3 3zm-6.879-4.935-2.236-4.473 5.912-.696zm-1.761.819c-.307-1.206-1.102-2.217-2.161-2.811l.52-1.457 2.115 4.229zm-4.36 4.116c-1.657 0-3-1.343-3-3s1.343-3 3-3c.091 0 .182.004.271.012-.522 1.461-.977 2.736-.977 2.736-.128.357.032.748.36.918.121.063.262.094.408.082l2.896-.242c-.241 1.416-1.474 2.494-2.958 2.494zm1.684-5.483c.527.358.935.881 1.149 1.494l-1.735.145zm11.316-2.017c-.07 0-.14.001-.21.005l-1.305-6.005h2.015c.552 0 1-.448 1-1s-.448-1-1-1h-3c-.552 0-1 .448-1 1 0 .331.16.624.408.806l.438 2.016-7.175.844-.333-.666h1.162c.552 0 1-.448 1-1s-.448-1-1-1h-3c-.552 0-1 .448-1 1s.448 1 1 1h.162l.628 1.257c0 .001-.471 1.32-1.004 2.811-.255-.045-.518-.068-.786-.068-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.357 0 4.292-1.813 4.484-4.121l1.564-.13c.213-.014.422-.116.562-.313l4.3-6.019.414 1.905c-1.655.665-2.824 2.285-2.824 4.178 0 2.485 2.015 4.5 4.5 4.5s4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5z" />
    </svg>
  )
}
export default OptionBikeRackIcon
